"use client";

import { useQuery } from "@tanstack/react-query";

import {
  landlordDocumentService,
  type ListingApplicationDocuments,
} from "@/features/documents/services/landlord-document-service";
import { qk } from "@/lib/query/keys";

/**
 * What an advert requires, for the dialog shown when applying.
 *
 * `staleTime: 0` for the same reason as the landlord document list: expiry is
 * the whole point, and a cached answer that still shows a document as valid
 * after it has expired tells the student they can apply when they cannot.
 */
export function useListingDocuments(listingId: string | null, enabled = true) {
  return useQuery<ListingApplicationDocuments>({
    queryKey: qk.documents.forListing(listingId ?? ""),
    queryFn: ({ signal }) =>
      landlordDocumentService.getForListing(listingId as string, signal),
    enabled: Boolean(listingId) && enabled,
    staleTime: 0,
  });
}
